import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
            <p className="text-sm text-gray-600">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none space-y-8">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
            <p className="text-gray-700 leading-relaxed">
              This Privacy Policy describes how BRX Resource ("we," "us," or "our"), an India-registered private limited company, collects, uses, and discloses information in connection with this website (brxresource.com) and related services.
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              This policy applies only to information collected through this website. It does not apply to information collected offline or through other channels.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Information We Collect</h2>
            <p className="text-gray-700 leading-relaxed">
              We may collect the following types of information:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li><strong>Contact Information:</strong> When you submit an inquiry through our contact form, we collect your name, company name, work email address, and message content.</li>
              <li><strong>Usage Data:</strong> We may collect basic technical information such as IP address, browser type, device information, and pages visited through standard web server logs.</li>
              <li><strong>Cookies:</strong> This website may use essential cookies necessary for basic functionality. We do not use third-party advertising or tracking cookies.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. How We Use Information</h2>
            <p className="text-gray-700 leading-relaxed">
              Information collected through this website is used for the following purposes:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li>To respond to inquiries and communicate regarding potential vendor-to-vendor engagements</li>
              <li>To maintain and improve website functionality</li>
              <li>To comply with applicable legal and regulatory requirements</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Information Sharing and Disclosure</h2>
            <p className="text-gray-700 leading-relaxed">
              We do not sell, rent, or share personal information with third parties for their marketing purposes. We may share information:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li>With service providers who assist in website operations (subject to confidentiality obligations)</li>
              <li>When required by law, legal process, or government request</li>
              <li>To enforce our Terms of Use or protect our rights, property, or safety</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Data Retention</h2>
            <p className="text-gray-700 leading-relaxed">
              We retain information for as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required or permitted by law.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Security</h2>
            <p className="text-gray-700 leading-relaxed">
              We implement reasonable administrative, technical, and physical safeguards to protect information. However, no method of transmission over the internet or electronic storage is completely secure. We cannot guarantee absolute security.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Your Rights</h2>
            <p className="text-gray-700 leading-relaxed">
              Depending on your jurisdiction, you may have certain rights regarding your personal information, including the right to access, correct, or delete information we hold about you. To exercise these rights, please contact us at info@brxresource.com.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. International Data Transfers</h2>
            <p className="text-gray-700 leading-relaxed">
              As we are registered and operate in India, information collected through this website may be processed and stored in India. By using this website, you acknowledge this transfer and processing.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Changes to This Policy</h2>
            <p className="text-gray-700 leading-relaxed">
              We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated "Last Updated" date. Your continued use of the website after changes constitutes acceptance of the updated policy.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contact Us</h2>
            <p className="text-gray-700 leading-relaxed">
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Email: info@brxresource.com<br />
              Location: Noida, Uttar Pradesh, India
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link to="/" className="text-blue-900 hover:text-blue-800 font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;